navApp.default.directive('navcallout', [
  '$sanitize', 'templatePath', 'endpointDomain', 'NavStateService', function($sanitize, templatePath, endpointDomain, NavStateService) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'navcallout.html',
      controller: [
        '$scope', function($scope) {
          return $scope.navStateService = NavStateService;
        }
      ],
      link: function(scope, element, attrs) {
        scope.navkey = attrs['navkey'];
        scope.navlevel = attrs['navlevel'];
        scope.captionHtml = $sanitize(scope.item.callout.caption);
        scope.captionImage = scope.item.callout.image;
        scope.show = function() {
          return NavStateService.currentCallout[scope.navkey].uid === scope.item.uid;
        };
        return scope.sizer = function() {
          return NavStateService.calloutSizer(scope.navkey);
        };
      }
    };
  }
]);
